<template lang="pug">
  SspLayout.shipment-details-page(area="tnt")
    template(slot="actions")
      .shipment-buttons(v-if="shipment")
        button.btn.btn-default(@click="recieve" :disabled="shipment.status !== 'SHIPPED'")
          i.fa.fa-flag
          span.ml5 Recieve

        button.btn.btn-default(@click="showPermissionsDialog")
          i.fa.fa-users
          span.ml5 Permissions

        button.btn.btn-default(@click="readyShipment" :disabled="!shipment.freePicking && skus.length === 0" v-if="shipment.status === 'INITIAL'")
          i.fa.fa-edit
          span.ml5 Ready

        router-link.btn.btn-default(:to="{name: 'editShipment', params: {id: shipmentId}}" v-if="shipment.status !== 'SHIPPED'")
          i.fa.fa-edit
          span.ml5 Edit

        button.btn.btn-default(@click="approve" :disabled="shipment.size === 0" v-if="shipment.status === 'CLOSED'")
          i.fa.fa-edit
          span.ml5 Approve

        button.btn.btn-default(@click="ship" v-if="shipment.status === 'SHIPMENT_READY'")
          i.fa.fa-ship
          span.ml5 Ship

        button.btn.btn-default(@click="close" v-if="shipment.status === 'READY_FOR_PICKING'")
          i.fa.fa-times
          span.ml5 Close

        button.btn.btn-default(@click="reopen" v-if="shipment.status === 'CLOSED'")
          i.fa.fa-external-link
          span.ml5 Reopen

    ShipmentDetails(v-if="shipment" :shipment="shipment" :skus="skus" :items="items")

    .row(v-if="shipment")
      .col-sm-12
        form.panel.panel-default(@submit.prevent="addCodeItems()")
          .panel-body
            .row
              .col-sm-12
                div(v-if="shipment.status === 'INITIAL' && !shipment.freePicking")
                  label.col-sm-2.pt10 Add product
                  .col-sm-6
                    ProductSelect(v-model="productId")
                  .col-sm-2
                    input.form-control(v-model="count" placeholder="Count")
                  .col-sm-2
                    button.btn.btn-primary(@click="addOrderItems" type="button" :disabled="!isValidProduct") Add
                div(v-if="shipment.status === 'READY_FOR_PICKING'")
                  label.col-sm-2.pt10 Add Codes
                  .col-sm-8
                    textarea.form-control.codes-textarea(v-model="codes" placeholder="Codes")
                  .col-sm-2
                    button.btn.btn-primary(type="submit" :disabled="!isValidCodes") Add

            .col-sm-4.col-sm-offset-2.pt20.red(v-if="errorMsg") {{errorMsg}}
    Permissions(ref="permissions")
</template>

<script>
import miniToastr from 'mini-toastr'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Permissions from '@/components/ssp/Permissions'
import ProductSelect from '@/components/ssp/ProductSelect'
import Util from '@/service/Util'
import ShipmentDetails from './ShipmentDetails'

export default {
  data: () => ({
    shipment: null,
    skus: null,
    items: null,
    codes: null,
    productId: null,
    count: null,
    errorMsg: null
  }),
  created() {
    this.getShipment()
  },
  methods: {
    addOrderItems() {
      const req = {}
      req.id = this.shipmentId
      if (this.productId) {
        req.productId = this.productId
      }
      req.count = this.count ? this.count : null

      TrackNTrace.addShipmentOrderItems(this.shipmentId, req)
        .then(() => {
          miniToastr.success('Product added to shipment')
          this.getShipment()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    addCodeItems() {
      const codes = Util.sanitizeCodes(this.codes)

      const req = {
        id: this.shipmentId,
        codes
      }

      TrackNTrace.addShipmentItems(this.shipmentId, req)
        .then(() => {
          miniToastr.success('Codes added to shipment')
          this.getShipment()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    handleSuccess(string) {
      miniToastr.success(`Shipment has been ${string}`)
      this.getShipment()
    },
    reopen() {
      TrackNTrace.reopenShipment({ id: this.shipmentId })
        .then(() => {
          this.handleSuccess('reopened')
        })
    },
    ship() {
      TrackNTrace.shipShipment(this.shipmentId)
        .then(() => {
          this.handleSuccess('shipped')
        })
    },
    approve() {
      TrackNTrace.approveShipment({ id: this.shipmentId })
        .then(() => {
          this.handleSuccess('approved')
        })
    },
    recieve() {
      this.$router.push({ name: 'receiveShipment', params: { code: this.shipment.code } })
    },
    readyShipment() {
      TrackNTrace.readyShipment({ id: this.shipmentId })
        .then(() => {
          this.handleSuccess('readied')
        })
    },
    close() {
      TrackNTrace.closeShipment({ id: this.shipmentId })
        .then(() => {
          this.handleSuccess('closed')
        })
    },
    showPermissionsDialog() {
      this.$refs.permissions.open('PICKING_LIST', this.shipmentId)
    },
    getShipment() {
      TrackNTrace.getShipment(this.shipmentId)
        .then((resp) => {
          this.shipment = resp.data.shipment
          this.skus = resp.data.skus
          this.shipmentStatus = this.shipment.status
          return resp.data.shipment.size
        })
        .then((size) => {
          if (size > 0) {
            TrackNTrace.getShipmentItems(this.shipmentId)
              .then((resp) => {
                this.items = resp.data.content
              })
          }
        })
    }
  },
  computed: {
    isValidCodes() {
      return this.codes
    },
    isValidProduct() {
      return this.productId
    },
    shipmentId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    ShipmentDetails,
    Permissions,
    ProductSelect
  }
}
</script>

<style lang="scss">
.shipment-details-page {
  .codes-textarea {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/shipments/Shipment.vue